import { render } from "./RegistrationCloudente.vue?vue&type=template&id=b7ffe494&scoped=true"
import script from "./RegistrationCloudente.vue?vue&type=script&lang=js"
export * from "./RegistrationCloudente.vue?vue&type=script&lang=js"

import "./RegistrationCloudente.vue?vue&type=style&index=0&id=b7ffe494&lang=scss"
import "./RegistrationCloudente.vue?vue&type=style&index=1&id=b7ffe494&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7ffe494"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBanner,QBtn,QTooltip,QIcon,QTd,QDialog,QCard,QToolbar,QToolbarTitle,QCardSection,QCardActions,QField});
